import FieldSet from '../../FieldSet';

import { PromotedRecordType } from './PromotedRecordType';
import { PromotedRecordName } from './PromotedRecordName';
import { PromotedRecordRef } from './PromotedRecordRef';
import { PromotedRecordStatusName } from './PromotedRecordStatusName';
import { PromotedRecordStatusPill } from './PromotedRecordStatusPill';

export class PromotedRecordFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [
      PromotedRecordType,
      PromotedRecordName,
      PromotedRecordRef,
      PromotedRecordStatusName,
      PromotedRecordStatusPill,
    ];
  }

  get title() {
    return 'Promoted to';
  }
}
